<template>
  <v-container
    v-if="ranking"
    v-show="!$apollo.loading"
    fill-height
    container--fluid
    grid-list-xl
  >
    <helper-buy-pack ref="buyPack" />
    <helper-suspended ref="suspended" />
    <v-layout wrap>
      <v-flex
        sm12
        xs12
        md4
      >
        <v-card class="project-card">
          <v-flex
            class="cover"
            :style="{ backgroundColor: ranking.project.bgcolor }"
            xs12
            md12
          >
            <v-avatar
              v-if="ranking.project.logo !== null"
              :tile="false"
              class="avatar"
              :size="110"
            >
              <v-img
                :src="ranking.project.logo"
                :lazy-src="ranking.project.logo"
                max-height="110"
                contain
              />
            </v-avatar>
            <v-avatar
              v-else
              class="avatar"
              style="pointer: cursor;"
              :tile="false"
              :size="110"
              color="#eceff1"
            >
              <strong
                class="avatar-invert"
                style="font-size:30px;"
              >
                {{ ranking.project.ticker | uppercase | substring(0, 2) }}
              </strong>
            </v-avatar>
          </v-flex>

          <v-flex
            class="description"
            xs12
            md12
          >
            <h4>{{ ranking.project.name }}</h4>
            <h5>
              {{ $t("globals.added") }}
              {{ ranking.created_at | moment("from", "now") }}
              {{
                ranking.project.datarooms && ranking.project.datarooms[0].name
              }}
            </h5>
            <p v-if="ranking.project.project_type == 'trader'">
              {{
                ranking.project.ownertype == "org"
                  ? $t("globals.organization")
                  : $t("globals.privateTrader")
              }},
              {{ country }}
            </p>
            <p v-if="ranking.project.project_type == 'bot'">
              <v-chip
                class="ma-1"
                color="primary"
                small
                outlined
                pill
              >
                {{ $t("bots.tradingBot") }}
              </v-chip>
              <br>{{ country }}
            </p>
            <center>
              <v-img
                v-if="ranking.project.exchange"
                class="text-center"
                :src="require(`@/images/${ranking.project.exchange}.png`)"
                max-width="100"
                contain
              />
            </center>
           
            <v-btn
              class="bordered round back"
              icon
              text
              small
              @click="$router.go(-1)"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <v-btn
              icon
              class="favorite"
              text
              small
              @click="mutateWatchList"
            >
              <v-icon>
                {{
                  ranking.project.is_favorite
                    ? "mdi-heart"
                    : "mdi-heart-outline"
                }}
              </v-icon>
            </v-btn>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex md8>
        <v-card class="overview-card">
          <v-flex
            xs12
            md12
          >
            <v-layout
              wrap
              data
            >
              <v-flex md3>
                <span>{{ $t("globals.ticker") }}</span>
                <p class="text-primary">
                  {{ ranking.project.ticker }}
                </p>
              </v-flex>

              <v-flex md3>
                <span>{{ $t("globals.roi") }}
                  <v-tooltip
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        style="margin-left:-5px;margin-top:-3px;"
                        v-on="on"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    {{ $t("rankings.roiExplained") }}
                  </v-tooltip>
                </span>
                <p :class="colorPnL(ranking.roi)">
                  {{ ranking.roi }}%
                </p>
              </v-flex>
              <v-flex md3>
                <span>{{ $t("globals.investors") }}</span>
                <p>{{ ranking.connected_investor_accounts }}</p>
              </v-flex>
              <v-flex
                md3
                text-right
              >
                <template v-if="connectDisabled && tooltip == 1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-btn
                          :disabled="connectDisabled"
                          class="primary ma-1 join"
                          @click="connectTrader()"
                        >
                          {{ $t("rankings.joinButton") }}
                        </v-btn>
                      </div>
                    </template>
                    {{ $t("rankings.testRisk") }}
                    {{ $t("rankings.testingTooltip2") }}
                  </v-tooltip>
                </template>
                <template v-if="connectDisabled && tooltip == 2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-btn
                          :disabled="connectDisabled"
                          class="primary ma-1 join"
                          @click="connectTrader()"
                        >
                          {{ $t("rankings.joinButton") }}
                        </v-btn>
                      </div>
                    </template>
                    {{ $t("rankings.reachedTooltip1") }}
                    <b>{{ ranking.project.name }}</b>
                    {{ $t("rankings.reachedTooltip2") }}
                  </v-tooltip>
                </template>
                <v-btn
                  v-if="!connectDisabled"
                  class="primary ma-1 join"
                  @click="connectTrader()"
                >
                  {{ $t("rankings.joinButton") }}
                </v-btn>
              </v-flex>
            </v-layout>

            <v-divider
              wrap
              style="margin:-15px 0 0 0;"
            />

            <v-layout
              wrap
              data
            >
              <v-flex
                md4
                xs6
                mrg
              >
                <span>{{ $t("globals.aum2") }}</span>
                <p class="text-primary balance">
                  {{ ranking.project.base_currency | renderSymbol }} {{ ranking.aum | formatMoney }}
                </p>
                <span>{{ $t("rankings.ownAssets") }}</span>
                <p>
                  {{ ranking.project.base_currency | renderSymbol }} 
                  {{
                    ranking.project.own_assets == null
                      ? 0
                      : ranking.project.own_assets
                      | formatMoney }}
                </p>
                <span>{{ $t("globals.minDeposit") }}</span>
                <p>
                  {{ ranking.project.base_currency | renderSymbol }} 
                  {{ ranking.project.mindeposit | formatMoney }}
                </p>
                <span>{{ $t("globals.maxDeposit") }}</span>
                <p>
                  {{ ranking.project.base_currency | renderSymbol }} 
                  {{
                    (ranking.project.maxdeposit > 0
                      ? ranking.project.maxdeposit
                      : "∞") | formatMoney
                  }}
                </p>
                <span>{{ $t("globals.allowedInvestors") }}</span>
                <p>
                  {{
                    ranking.project.maxinvestors > 0
                      ? ranking.project.maxinvestors
                      : "∞"
                  }}
                </p>
              </v-flex>
              <v-flex
                md4
                xs6
                mrg
              >
                <span>{{ $t("rankings.copyTrading") }}</span>
                <v-tooltip
                  top
                  min-width="300px"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t(ranking.project.type == 'trading.copy' ? "rankings.copyTradingHint" : "rankings.keyTradingHint") }}
                </v-tooltip>
                <p>{{ $t(ranking.project.type == 'trading.copy' ? "bots.yes" : "bots.no") }}</p>
                <span>{{ $t("rankings.successFee") }}</span>
                <p>{{ ranking.project.management_fee + ranking.project.referral_fee + 5 }}%</p>
                <span>{{ $t("globals.leverage") }}</span>
                <p>{{ ranking.project.leverage }}</p>
                <span>{{ $t("globals.allowedDrawdown") }}</span>
                <p>{{ ranking.project.drawdown }}%</p>
               
                <span>{{ $t("rankings.riskRatio") }}</span>
                <v-tooltip
                  top
                  min-width="300px"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t("rankings.riskHint") }}
                </v-tooltip>
                <p>
                  1:{{ ranking.project.risk_ratio }}
                </p>
              </v-flex>
              <v-flex
                md4
                xs12
                pnl-block
              >
                <span>{{ $t("globals.pnl") }}</span>
                <div class="pnl">
                  <span>{{ $t("rankings.24hours") }}</span>
                  <p :class="colorPnL(ranking.pnl_last_1day)">
                    {{ ranking.pnl_last_1day }}%
                  </p>
                </div>
                <div class="pnl">
                  <span>{{ $t("rankings.48hours") }}</span>
                  <p :class="colorPnL(ranking.pnl_last_2days)">
                    {{ ranking.pnl_last_2days }}%
                  </p>
                </div>
                <div class="pnl">
                  <span>{{ $t("rankings.7days") }}</span>
                  <p :class="colorPnL(ranking.pnl_last_7days)">
                    {{ ranking.pnl_last_7days }}%
                  </p>
                </div>
                <div class="pnl">
                  <span>{{ $t("rankings.30days") }}</span>
                  <p :class="colorPnL(ranking.pnl_last_30days)">
                    {{ ranking.pnl_last_30days }}%
                  </p>
                </div>
                <div class="pnl">
                  <span>{{ $t("rankings.3months") }}</span>
                  <p :class="colorPnL(ranking.pnl_last_3month)">
                    {{ ranking.pnl_last_3month }}%
                  </p>
                </div>
                <div class="pnl">
                  <span>{{ $t("rankings.6months") }}</span>
                  <p :class="colorPnL(ranking.pnl_last_6month)">
                    {{ ranking.pnl_last_6month }}%
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex md12>
        <v-tabs :value="getActiveTab">
          <v-tab
            v-for="(n, i) in tabsArray"
            :key="i"
            @click="changeTab(i)"
          >
            {{ n }}
          </v-tab>
        </v-tabs>
        <v-card class="details-card">
          <v-flex
            v-show="getActiveTab == 0"
            xs12
            md12
            data
          >
            <span>{{ $t("rankings.about") }} {{ ranking.project.name }}</span>
            <p>{{ ranking.project.description }}</p>

            <span>{{ $t("rankings.management") }}</span>
            <p>{{ ranking.project.management }}</p>
          </v-flex>
          <trader-result
            v-if="getActiveTab == 1 && !$apollo.loading"
            :project-id="ranking.project.id"
          />
          <v-divider v-if="getActiveTab == 1" />
          <trader-performance
            v-if="getActiveTab == 1 && !$apollo.loading"
            :performance="ranking.performance_series"
          />
          <v-divider v-if="getActiveTab == 1" />
          <trader-balance-chart
            v-if="getActiveTab == 1 && !$apollo.loading"
            :project-id="ranking.project.id"
            :base-currency="ranking.project.base_currency"
          />
          <investor-performance
            v-if="getActiveTab == 2 && !$apollo.loading"
            :project-id="ranking.project.id"
          />
          <span
            v-if="getActiveTab !== 0"
            class="performance_note text-center"
          >{{ $t("globals.statsUpdated") }}</span>
        </v-card>
      </v-flex>
      
      <connect-project-dialog
        v-if="connectDialog"
        :show-dialog="connectDialog"
        :drawdown="ranking.project.drawdown"
        :project-type="ranking.project.type"
        :risk-ratio="ranking.project.risk_ratio"
      />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TraderPerformance from "@/views/Rankings/partial/TraderPerformance.vue";
import TraderBalanceChart from "@/views/Rankings/partial/TraderBalanceChart.vue";
import TraderResult from "@/views/Rankings/partial/TraderResult.vue";
import InvestorPerformance from "@/views/Rankings/partial/InvestorPerformance.vue";
import ConnectProjectDialog from "@/views/Rankings/partial/ConnectProjectDialog.vue";

const RANKING_QUERY = require("@/graphql/queries/Ranking.gql");
const ADD_WATCHLIST_MUTATION = require("@/graphql/mutations/AddToWatchlist.gql");
const REMOVE_WATCHLIST_MUTATION = require("@/graphql/mutations/RemoveFromWatchlist.gql");

export default {
  name: "RankingView",
  components: {
    TraderPerformance,
    TraderBalanceChart,
    TraderResult,
    InvestorPerformance,
    ConnectProjectDialog
  },
  data: () => ({
    tab: 0,
    userStatus: null,
    auth: localStorage.getItem("auth-token") != null,
    country: null,
    loading: false,
    connectDialog: false,
    ranking: {
      performance: [],
      project: {
        bgcolor: "#0a61f0"
      }
    }
  }),
  computed: {
    ...mapGetters("ranking", ["getActiveTab", "getRanking"]),
    ...mapGetters("user", ["getUser"]),
    tabsArray() {
      let tabs = []
      const performance = this.ranking.project.project_type == 'trader' ? 'rankings.traderPerformance' : 'rankings.botPerformance'
      tabs.push(this.$t('globals.description'))
      tabs.push(this.$t(performance))

      if (this.getUser && (this.getUser.pack == 'Premium' || this.getUser.pack == 'VIP')) {
        tabs.push(this.$t('rankings.investorPerformance'))
      }
      return tabs
    },
    countryList() {
      return require("@/lang/" + this.$i18n.locale + "/country.json");
    },
    tooltip() {
      if (this.ranking.project.status == "incubation") {
        return 1;
      }
      if (
        this.ranking.project.maxinvestors !== 0 &&
        this.ranking.project.maxinvestors ==
          this.ranking.connected_investor_accounts
      ) {
        return 2;
      }
      return null;
    },
    connectDisabled() {
      if (!this.auth) return true;
      if (this.ranking.project.status == "incubation") {
        return true;
      }
      if (
        this.ranking.project.maxinvestors !== 0 &&
        this.ranking.project.maxinvestors ==
          this.ranking.connected_investor_accounts
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.setTab(1);
    if (
      this.$route.query.a !== undefined &&
      this.$route.query.a.length === 10
    ) {
      this.$cookie.set("sp", this.$route.query.a, { expires: "1M" });
    }
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "user/setUserSettings") {
        if (state.user.userSettings != undefined) {
          this.userStatus = state.user.userSettings.status
        }
      }
    });
  },
  beforeDestroy() {
    this.setRanking({});
  },
  methods: {
    connectTrader() {
      if (this.userStatus == 'suspended') {
        this.$refs.suspended.open();
        return;
      }
       if (this.getUser.pack == null && !this.getUser.vip_client) {
         this.$refs.buyPack.open();
         return;
       }
      this.connectDialog = true;
    },
    ...mapMutations("ranking", ["setTab", "setRanking"]),
    changeTab(i) {
      this.setTab(i);
    },
    mutateWatchList() {
      let MUTATION = ADD_WATCHLIST_MUTATION;
      if (this.getRanking.project.is_favorite == true)
        MUTATION = REMOVE_WATCHLIST_MUTATION;
      this.$apollo
        .mutate({
          mutation: MUTATION,
          variables: {
            id: this.ranking.project.id
          },
          update: store => {
            const data = store.readQuery({
              query: RANKING_QUERY,
              variables: { id: this.ranking.id }
            });
            data.ranking.project.is_favorite = !data.ranking.project
              .is_favorite;
            store.writeQuery({ query: RANKING_QUERY, data });
          }
        })
        .then(data => {
          this.responseHandler(data);
        })
        .catch(error => {
          this.errorHandler(error);
        });
    }
  },
  apollo: {
    ranking: {
      query: RANKING_QUERY,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      result(result) {
        if (!result.loading) {
          if (!result.data.ranking) {
            this.$router.push('/rankings')
            return
          }
          this.setRanking(result.data.ranking);
          this.country = this.countryList[this.ranking.project.country];
        }
      }
    }
  }
};
</script>

<style lang="scss">
.project-card {
  padding: 0;
  height: 100%;
  .cover {
    height: 100px;
    background-color: #0a61f0;
    .avatar {
      position: absolute;
      left: 50%;
      top: 40px;
      transform: translate(-50%, 0);
      overflow: hidden;
      z-index: 1;
    }
  }
  .description {
    margin-top: 50px;
    h4,
    h5 {
      line-height: 24px !important;
    }

    h4 {
      text-align: center;
      font-weight: 700 !important;
      margin: 0 !important;
    }
    h5 {
      margin: 10px 0 0 !important;
      text-align: center;
      font-weight: 400 !important;
      font-size: 15px !important;
      color: #7f97ab;
      display: block;
    }
    p {
      text-align: center;
      font-weight: 400;
      font-size: 12px;
    }
    .favorite {
      position: absolute;
      right: -2px;
      bottom: 0;
    }
    .back {
      position: absolute;
      left: 12px;
      bottom: 12px;
      width: 20px;
      height: 20px;
      .v-icon {
        margin-top: 1px;
        font-size: 0.85rem;
      }
    }
  }
}
.overview-card {
  .data {
    padding: 10px;
    .v-icon {
      margin-left: 4px;
      font-size: 16px;
    }
    .balance {
      font-weight: 700;
      font-size: 19px;
    }
    .v-btn__content {
      color: #fff;
      font-size: 15px;
    }
    .mrg {
      p {
        margin-bottom: 12px;
      }
    }
    span {
      font-size: 11px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      font-size: 16px;
      font-weight: 700;
    }
    .pnl-block {
      .pnl {
        display: table;
        border-bottom: 1px solid #eee;
        width: 100%;
        height: 39px;

        span {
          display: table-cell;
          font-size: 13px;
          vertical-align: middle;
        }
        p {
          display: table-cell;
          text-align: right;
          vertical-align: middle;
          font-weight: 600;
          font-size: 15px;
        }
      }
    }
  }
}
.details-card {
  .data {
    padding: 10px;
    span {
      font-size: 12px;
      font-weight: 600;
      color: #7f97ab;
    }
    p {
      font-size: 15px;
      font-weight: 400;
    }
  }
}
</style>
